import Module from '../module';
import scroll from '../../libs/scroll/scroll';

import sliderListCutFactory, { PublicVarsInterface as SliderListCutSetupInterface } from '../../libs/slider/slider-list-cut';

interface OptionsInterface {
	cssId: {
		anim?: {
			homeCorporateMediaCarouselArrowLeftId: string;
			homeCorporateMediaCarouselArrowRightId: string;
			homeCorporateMediaCarouselPagerWrapperId: string;
			homeCorporateMediaCarouselId: string;
		}
	},

	sliderListCutSetup?: SliderListCutSetupInterface

	slug: string
}

class Corporate extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Home Corporate Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		if(!this.publicVars.sliderListCutSetup) {
			this.errorMsg('sliderSetup is not defined');
		} else {
			const slider = sliderListCutFactory.create();
			slider.init(this.publicVars.sliderListCutSetup);
		}

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeCorporateMediaCarouselArrowLeftId || '', 'home_corporate', { animCls: 'animate__fadeInLeft', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeCorporateMediaCarouselArrowRightId || '', 'home_corporate', { animCls: 'animate__fadeInRight', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeCorporateMediaCarouselPagerWrapperId || '', 'home_corporate', { animCls: 'animate__fadeIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeCorporateMediaCarouselId || '', 'home_corporate', { animCls: 'animate__fadeIn', once: true});

	}

	bind() {
		this.msg('bind');
	}
}

export default Corporate;